/**
 * Analytics Configuration
 * 
 * Centralized tracking configuration for GA4 and Meta Pixel.
 * All tracking is disabled by default and respects user consent.
 */

// Environment-based configuration
export const ANALYTICS_CONFIG = {
  // Tracking IDs from environment
  GA4_MEASUREMENT_ID: process.env.REACT_APP_GA4_MEASUREMENT_ID || '',
  META_PIXEL_ID: process.env.REACT_APP_META_PIXEL_ID || '',
  
  // Master toggle - must be explicitly enabled
  TRACKING_ENABLED: process.env.REACT_APP_ENABLE_TRACKING === 'true',
  
  // Cookie banner toggle
  COOKIE_BANNER_ENABLED: process.env.REACT_APP_ENABLE_COOKIE_BANNER !== 'false', // Default true
  
  // Consent storage key
  CONSENT_STORAGE_KEY: 'cds_tracking_consent',
};

/**
 * Check if GA4 is configured and enabled
 */
export const isGA4Enabled = () => {
  return ANALYTICS_CONFIG.TRACKING_ENABLED && 
         ANALYTICS_CONFIG.GA4_MEASUREMENT_ID.length > 0;
};

/**
 * Check if Meta Pixel is configured and enabled
 */
export const isMetaPixelEnabled = () => {
  return ANALYTICS_CONFIG.TRACKING_ENABLED && 
         ANALYTICS_CONFIG.META_PIXEL_ID.length > 0;
};

/**
 * Check if any tracking is configured
 */
export const isTrackingConfigured = () => {
  return isGA4Enabled() || isMetaPixelEnabled();
};

/**
 * Get user consent status from localStorage
 * @returns {'accepted' | 'rejected' | null}
 */
export const getConsentStatus = () => {
  try {
    return localStorage.getItem(ANALYTICS_CONFIG.CONSENT_STORAGE_KEY);
  } catch {
    return null;
  }
};

/**
 * Set user consent status
 * @param {'accepted' | 'rejected'} status
 */
export const setConsentStatus = (status) => {
  try {
    localStorage.setItem(ANALYTICS_CONFIG.CONSENT_STORAGE_KEY, status);
  } catch {
    console.warn('Unable to store consent preference');
  }
};

/**
 * Check if user has accepted tracking
 */
export const hasAcceptedTracking = () => {
  return getConsentStatus() === 'accepted';
};

/**
 * Check if consent banner should be shown
 */
export const shouldShowConsentBanner = () => {
  return ANALYTICS_CONFIG.COOKIE_BANNER_ENABLED && 
         isTrackingConfigured() && 
         getConsentStatus() === null;
};

export default ANALYTICS_CONFIG;
